<template>
    <el-checkbox-group
        v-model="newCheckList"
        :disabled="disabled"
        :min="1"
    >
        <el-checkbox label="active_day" class="availability-checkbox">
            day
        </el-checkbox>
        <el-checkbox label="active_night" class="availability-checkbox">
            night
        </el-checkbox>
        <el-checkbox label="active_weekend" class="availability-checkbox">
            weekend
        </el-checkbox>
    </el-checkbox-group>
</template>

<script>

export default {

    components: {

    },

    props: {
        active_day: {
            type: Boolean,
            required: true,
        },
        active_night: {
            type: Boolean,
            required: true,
        },
        active_weekend: {
            type: Boolean,
            required: true,
        },
        disabled: {
            type: Boolean,
            required: true,
        },
    },

    data: function(){
        return {
            newCheckList: [],
            params: ['active_day', 'active_night', 'active_weekend'],
        };
    },

    computed: {

    },

    watch: {
        newCheckList(val) {
            this.$emit('updateAvailability', val);
        }
    },

    mounted: function(){
        for (let param of this.params) {
            if (this[param]) {
                this.newCheckList.push(param);
            }
        }
    },

    methods: {
    },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/page/ManageAlarmAlertNotification/availability-checklist.vue